let workerURL = require('./helpers/get-worker-url');
let bundleURL = require('./helpers/bundle-url');
let url = bundleURL.getBundleURL('3p50z') + "word-diff.worker.302f21f3.js";module.exports = workerURL(url, bundleURL.getOrigin(url), false);